/* istanbul ignore file */
const getCacheStrategyDetails = (functionName, args) => {
  let doHash = true;
  let cacheArgs = args;
  let simpleReturn = false; // success response caches 'pass'
  if (functionName.includes('ReadMerchantPersonalizationTypeahead')) {
    doHash = false;
    cacheArgs = args.keyword;
  } else if (functionName.includes('ReadMerchantMapOffers') || functionName.includes('ReadMerchantMapEnrolledOffers')) {
    cacheArgs = args.query.cl + args.query.nw + args.query.se + args.accountKey;
  } else if (functionName.includes('ReadMerchantMapsTabOffers')) {
    doHash = false;
    cacheArgs = args.merchantOffer;
  } else if (functionName.includes('CreateMerchantMapOffersEnrollment')) {
    doHash = false;
    cacheArgs = args.offer.treatment_identifier;
    simpleReturn = true;
  } else if (functionName.includes('ReadMerchantMapIndustryBonusCategories')) {
    cacheArgs = `${args.accountKey}/${args.pathname}`;
  } else if (functionName.includes('ReadMerchantMapRecommendation')) {
    doHash = true;
    cacheArgs = `${args.accountKey}/${args.search}/${args.pathname}`;
  } else if (functionName.includes('ReadMerchantPublicMapRecommendation')) {
    doHash = true;
    cacheArgs = `${args.search}/${args.pathname}`;
  } else if (functionName.includes('CreateMerchantEditSuggestion')) {
    doHash = false;
    cacheArgs = args.requestObj.merchant.identifier;
    simpleReturn = true;
  }

  return {
    doHash,
    cacheArgs,
    simpleReturn,
  };
};

export default getCacheStrategyDetails;
